import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';
import {ConferencePpt} from "../biz-conference/biz-conference.component";

@Injectable({
    providedIn: 'root'
})
export class BizConferenceApiService {

    private apiUrl = `${API_URL}` + 'biz-conference';

    constructor(private http: HttpClient) {
    }

    createConferenceEntry(data: any): Observable<any> {
        return this.http.post<any>(this.apiUrl, data);
    }

    updateConferenceEntry(id: string, data: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}/${id}`, data);
    }

    getConferenceEntry(id: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${id}`);
    }

    getAllEntries(): Observable<any> {
        return this.http.get<any>(this.apiUrl);
    }

    deleteEntry(id: string): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }

    // Stripe checkout session API. /create-checkout-session
    createStripeSession(data: any): Observable<any> {
        return this.http.post<any>(`${API_URL}payment/create-biz-checkout-session`, data);
    }

    /* ----------------------------
    * SPEAKER PPT UPLOAD (NEW FLOW)
    * ---------------------------- */

    uploadSpeakerPresentation(
        speakerId: string,
        formData: FormData
    ): Observable<any> {
        /**
         * formData must contain:
         * - file : ppt / pptx
         */
        return this.http.put<any>(
            `${API_URL}business-conference/speaker/${speakerId}/upload`,
            formData
        );
    }

    /* ----------------------------
     * SPEAKER PPT DOWNLOAD
     * ---------------------------- */

    downloadSpeakerPresentation(
        speakerId: string,
        filename: string,
        isLocal: boolean
    ): Observable<any> {

        if (isLocal) {
            return this.http.get(
                `${API_URL}business-conference/speaker/${speakerId}/download/${filename}`,
                { responseType: 'blob' }
            );
        }

        // PROD: get pre-signed download URL
        return this.http.get<{ downloadUrl: string }>(
            `${API_URL}business-conference/speaker/${speakerId}/generate-presigned-download-url`,
            { params: { filename } }
        );
    }



    // Save PPT metadata in Biz Conference API
    savePptMetadata(speakerId: string, pptData: Partial<ConferencePpt>) {
        return this.http.post<ConferencePpt>(
            `${this.apiUrl}/speaker/${speakerId}/ppt`,
            pptData
        );
    }

    // Optional: get PPTs for a speaker
    getSpeakerPpts() {
        return this.http.get<ConferencePpt[]>(`${this.apiUrl}/speaker/ppt`);
    }
}
